var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.group === 'Admin')?_c('div',{},[_c('HomeUser')],1):(_vm.group === 'Company-Admin')?_c('HomeUser'):_c('HomePageEmployees')
}
var staticRenderFns = []

export { render, staticRenderFns }